import {
    forgotPassword as ForgotPasswordService,
    fetchAmplifyContext as fetchAmplifyContextService,
} from '/b2b/authentication/services';

import AmplifyActions from '/b2b/authentication/state/amplify/Amplify.actions';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { updateAuth } from '/b2b/amplify.config';

const sendResetCode = params => dispatch => {
    dispatch(AuthActions.forgotPasswordBegin(params));
    return ForgotPasswordService(params)
        .then(resetPasswordOutput => {
            dispatch(AuthActions.forgotPasswordSuccess(params, resetPasswordOutput));
            dispatch(AmplifyActions.nextStep(resetPasswordOutput));
            return { ssoEnabled: false };
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.forgotPasswordFailure(params, message));
            throw message;
        });
};

export const onSendResetCode = params => dispatch => {
    const { username } = params;
    dispatch(AuthActions.fetchSignInContextBegin(params));

    return fetchAmplifyContextService({ username })
        .then(context => {
            const formattedContext = updateAuth(context);
            dispatch(AuthActions.fetchSignInContextSuccess(params, formattedContext));
            return formattedContext.ssoEnabled === true;
        })
        .catch(error => {
            // Fall back to the native pool so the reset code still goes out
            dispatch(AuthActions.fetchSignInContextFailure(params, error));
            updateAuth();
            return false;
        })
        .then(ssoEnabled => {
            if (ssoEnabled) {
                return { ssoEnabled };
            }
            return sendResetCode(params)(dispatch);
        });
};
